export enum SolidLinkColorSchemas {
  PURPLE = 'purple',
  WHITE = 'white',
  TRANSPARENT = 'transparent',
  HIGHLIGHTED = 'highlighted',
}
